import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Asset from '@/plugins/sdk/resources/Asset'
import Account from '@/plugins/sdk/resources/Account'
import Team from '@/plugins/sdk/resources/Team'
import Profile from '@/plugins/sdk/resources/Profile'
import Note from '@/plugins/sdk/resources/Note'

export default class extends Resource {
  static name = 'asset_history'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      date_out: new DATETIME(),
      date_in: new DATETIME(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      asset: new ITEM(Asset),
      account: new ITEM(Account),
      team: new ITEM(Team),
      profile: new ITEM(Profile),
      notes: new COLLECTION(Note)
    }
  }
}
